let statItems = {};

jQuery.extend(
  (jQuery.expr[":"].containsCI = function (a, i, m) {
    //-- faster than jQuery(a).text()
    var sText = a.textContent || a.innerText || "";
    var zRegExp = new RegExp(m[3], "i");
    return zRegExp.test(sText);
  })
);

$(document).ready(function () {
  // Escuchar el evento "keyup" en el campo de texto
  $("body").on("keyup", ".input-filter-list", function (event) {
    // Verificar si se ha presionado la tecla "Enter" (código 13)

    // Obtener el contenido del campo de texto
    const searchText = $(this).val().trim();

    // Separar el contenido por comas para obtener los elementos
    const searchItems = searchText.split(",");

    const context = jQuery(this).closest(".mylist");
    let listaIdSeparadaPorComas = "";
    itemElement.resetContador(context);
    if (searchItems.length > 0 && searchText != "") {
      //jQuery('.milista-element',context).data("contador",0);

      if (jQuery(this).closest(".mylist").hasClass("listItemsA")) {
        selectionListA = searchItems;
      } else {
        selectionListB = searchItems;
      }
      // Remover cualquier marca previa antes de buscar y marcar coincidencias
      $(".badge", context).removeClass("highlight");
      $(".badge", context).addClass("offFilter");

      if (searchText == "" || searchText == " ") {
        $(".badge", context).removeClass("offFilter");
      }
      // Buscar y marcar las coincidencias
      searchItems.forEach(function (item) {
        if (item != "" && item != " ") {
          console.log(item);
          const itemLowercase = " " + item.trim().toUpperCase() + " ";
          const $matchedElements = $(
            ".badge:containsCI(" + itemLowercase + ")",
            context
          );
          console.log('"' + itemLowercase + '"');
          console.log("BEGIN matchedElements:");
          console.log($matchedElements);
          console.log("END matchedElements:");
          $matchedElements.addClass("highlight");

          $matchedElements.each(function (index, element) {
            /* const numero_de_repeticiones = $(this)
            .closest(".milista-element")
            .data("contador")??0;

            $(this)
            .closest(".milista-element")
            .data("contador",numero_de_repeticiones+1);
            */
            itemElement.setContadorFromChild($(this));
          });
        }
      });

      const elementosSeleccionados = $(".badge.highlight .number", context);

      console.log("elementosSeleccionados:");
      console.log(elementosSeleccionados);
      // Obtener el contenido de cada elemento y separarlos por comas
      const listaSeparadaPorComas = elementosSeleccionados
        .map(function () {
          if ($(this).closest(".milista-element").data("contador") > 0) {
            const numero_de_repeticiones = $(this)
              .closest(".milista-element")
              .data("contador");
            const numero_a_repetir = $(this).text();
            const resultado = [];

            for (let i = 0; i < numero_de_repeticiones; i++) {
              resultado.push(numero_a_repetir);
            }

            r = resultado.join(",");
          } else {
            r = $(this).text();
          }

          return r;
        })
        .get()
        .join(", ");
      //continuar aqui, y hacer que los totoles y las repeditciones se vean
      listaIdSeparadaPorComas = elementosSeleccionados
        .map(function () {
          let r = "";
          if ($(this).closest(".milista-element").data("contador") > 0) {
            const numero_de_repeticiones = $(this)
              .closest(".milista-element")
              .data("contador");
            const numero_a_repetir = $(this)
              .closest(".milista-element")
              .data("id");
            const resultado = [];

            for (let i = 0; i < numero_de_repeticiones; i++) {
              resultado.push(numero_a_repetir);
            }

            r = resultado.join(",");
          } else {
            r = $(this).closest(".milista-element").data("id");
          }
          return r;
        })
        .get()
        .join(", ");

      //jQuery("input.listIds", context).val(listaIdSeparadaPorComas);

      let relieves = 0;
      let especiales = 0;
      let normales = 0;
      let textRelieves = "";
      let textEspeciales = "";
      let textNormales = "";

      let statItems = [];
      typesOfItems.forEach(function (type) {
        type_id = type.id;
        elementos = $(".badge.highlight.type-" + type_id + " .number", context);

        tempContent = [];

        qualitiesOfItems.forEach(function (qualitie) {
          qualitie_title = qualitie.label;
          qualiti_total = 0;
          qualiti_list = "";
          elementos.each(function (item) {
            if (
              jQuery(this)
                .closest(".badge")
                .hasClass("qualities-" + qualitie.keyname)
            ) {
              cantidad = jQuery(this).closest(".badge").data("contador") ?? 1;

              if (cantidad > 1) {
                resultado = new Array(cantidad).fill(jQuery(this).text());

                r = resultado.join(",");
              } else {
                r = jQuery(this).text();
              }
              qualiti_total = qualiti_total + cantidad;

              
               if(qualiti_list=='')
               {
                qualiti_list =  r;
               }else{
                qualiti_list = qualiti_list + ", " + r;
               }

            }
          });

          if (qualiti_total > 0) {
            objTemp = {};

            (objTemp[qualitie_title] =
              "(" + qualiti_total + "): " + qualiti_list),
              tempContent.push(objTemp);
          }
        });

        if (tempContent.length > 0) {
          statItems[type.title] = tempContent;
        }
      });

      let html = "<ul>";

      //statItems.forEach(function(stat,index){
      html =
        html +
        "<li class='read'><b>Total de items(" +
        listaSeparadaPorComas.split(",").length +
        ")</b>:" +
        listaSeparadaPorComas +
        "";
      for (const index in statItems) {
        html = html + "<li  class='read'><b>" + index + "</b></li>";
        html = html + "<li><ul>";
        statItems[index].forEach(function (qualities, index) {
          keysArray = Object.keys(qualities);

          html =
            html +
            "<li  class='read'><span>----</span>" +
            keysArray[0] +
            "" +
            qualities[keysArray[0]] +
            "</li>";
        });
        html = html + "</ul>";
        html = html + "</li>";
      }
      //});
      html = html + "</ul>";

      if (elementosSeleccionados.length > 0) {
        jQuery(".filterResult", context).html(html);
        jQuery(".boton-copiar", context).show();
      } else {
        jQuery(".filterResult", context).html("");
        jQuery(".boton-copiar", context).hide();
      }
    } else {
      jQuery(".filterResult", context).html("");
    }

    //Actualizando los ides
    itemElement.updateListIds(context, listaIdSeparadaPorComas);
  });
});
